// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const PasswordFormTitle = styled.div`
  color: var(--mb-color-text-primary);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: center;
  margin-bottom: 1rem;
`;

export const PasswordFormMessage = styled.div`
  color: var(--mb-color-text-primary);
  text-align: center;
  margin-bottom: 1.5rem;
`;
